import { useContext } from 'react';
import ModalContext from './ModalContext';

/**
 * Hook for consumers to access modal actions.
 *
 * @returns {{ modalStack: import('./ModalContext').ModalEntry[], openModal: Function, closeModal: Function, wrapperScale: number, activeCount: number }}
 */
export const useModalContext = () => {
  const ctx = useContext(ModalContext);
  return ctx;
};
